import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationDE from './translations/de.json';
import translationEN from './translations/en.json';

// Import modular translations
import authEN from './translations/modules/auth.en.json';
import authDE from './translations/modules/auth.de.json';
import groupsEN from './translations/modules/groups.en.json';
import groupsDE from './translations/modules/groups.de.json';
import documentsEN from './translations/modules/documents.en.json';
import documentsDE from './translations/modules/documents.de.json';
import documentSourcesEN from './translations/modules/documentSources.en.json';
import documentSourcesDE from './translations/modules/documentSources.de.json';
import embeddingEN from './translations/modules/embedding.en.json';
import embeddingDE from './translations/modules/embedding.de.json';
import navigationEN from './translations/modules/navigation.en.json';
import navigationDE from './translations/modules/navigation.de.json';
import commonEN from './translations/modules/common.en.json';
import commonDE from './translations/modules/common.de.json';
import conversationEN from './translations/modules/conversation.en.json';
import conversationDE from './translations/modules/conversation.de.json';
import faqEN from './translations/modules/faq.en.json';
import faqDE from './translations/modules/faq.de.json';
import sharedFoldersEN from './translations/modules/sharedFolders.en.json';
import sharedFoldersDE from './translations/modules/sharedFolders.de.json';
import textExtractionEN from './translations/modules/textExtraction.en.json';
import textExtractionDE from './translations/modules/textExtraction.de.json';
import usersEN from './translations/modules/users.en.json';
import usersDE from './translations/modules/users.de.json';

// Merge main translations with modular translations
const mergedTranslationEN = {
  ...translationEN,
  ...authEN,
  ...groupsEN,
  ...documentsEN,
  ...documentSourcesEN,
  ...embeddingEN,
  ...navigationEN,
  ...commonEN,
  ...conversationEN,
  ...faqEN,
  ...sharedFoldersEN,
  ...textExtractionEN,
  ...usersEN
};

const mergedTranslationDE = {
  ...translationDE,
  ...authDE,
  ...groupsDE,
  ...documentsDE,
  ...documentSourcesDE,
  ...embeddingDE,
  ...navigationDE,
  ...commonDE,
  ...conversationDE,
  ...faqDE,
  ...sharedFoldersDE,
  ...textExtractionDE,
  ...usersDE
};

// the translations
const resources = {
  en: {
    translation: mergedTranslationEN
  },
  de: {
    translation: mergedTranslationDE
  }
};

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    fallbackLng: 'de', // Default is German
    debug: false,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    detection: {
      // Order of language detection
      order: ['cookie', 'navigator'],
      // Cookie options
      caches: ['cookie'],
      cookieMinutes: 525600, // 365 days in minutes (365 * 24 * 60)
      cookieOptions: {
        path: '/',
        sameSite: 'strict'
      }
    }
  });

export default i18n;
